import { render, staticRenderFns } from "./prix.vue?vue&type=template&id=02663319&scoped=true&"
import script from "./prix.vue?vue&type=script&lang=js&"
export * from "./prix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02663319",
  null
  
)

export default component.exports